import type { JSX } from "react";
import { FormattedMessage } from "react-intl";

import { UnitsClient } from "@citrine/resources/units";

interface FormattedUnitsProps {
  render?: (formattedUnits: string) => JSX.Element;
  units: string;
}

export function FormattedUnits({ render, units }: FormattedUnitsProps) {
  const formattedQuery = UnitsClient.getInstance().useFormatUnits(units);
  const formattedUnits = formattedQuery.data ?? units;

  return render ? render(formattedUnits) : <>{formattedUnits}</>;
}

function renderWithParentheses(formattedUnits: string) {
  return (
    <FormattedMessage
      id="units"
      values={{ units: formattedUnits || "dimensionless" }} // react-intl does not support select on empty
    />
  );
}

export function FormattedUnitsWithParentheses({ units }: { units: string }) {
  return <FormattedUnits render={renderWithParentheses} units={units} />;
}

export function ValueWithFormattedUnits({
  units,
  value,
  className,
}: {
  units?: string;
  value?: string | number;
  className?: string;
}) {
  return (
    <span>
      {value}
      {units ? (
        <span className={className}>
          {" "}
          <FormattedUnits units={units} />
        </span>
      ) : null}
    </span>
  );
}
